import {useContext} from "react";
import {TimelineFrameDataContext} from "../../../../../TimelineFramePage";
import {config} from "../../../../../../../definitions/TimelineItems";
import {getTime} from "../../../../../../../utils/TimeUtils";
import capitalize from "lodash/capitalize";
import {FormattedMessage} from "react-intl";

const TimelineFrameContentDateTime = () => {
    const { data } = useContext(TimelineFrameDataContext);
    const { hideHours } = {...config[data.type]};
    const momentTime = getTime(data.date);

    return (
        <>
            <p>
                <span>
                    {capitalize(momentTime.format('dddd '))}
                    {momentTime.format('D.M.YYYY ')}
                </span>
                {!hideHours && (
                    <span className="clock">
                        <FormattedMessage id={'clock'} />{' '}
                        {momentTime.format('H.mm')}
                    </span>
                )}
            </p>
        </>
    )
}
export default TimelineFrameContentDateTime;

